import { Checkbox, Group, NumberInput, Select, Text, TextInput } from '@mantine/core';
import { match } from 'ts-pattern';

interface PluginSettingItemProps {
  pluginkey: string;
  setting: {
    key: string;
    name: string;
    type: 'boolean' | 'number' | 'string' | 'select';
    default: any;
    value: any;
    options?: { value: string; label: string }[];
  };
  onSettingChange: (pluginKey: string, settingKey: string, value: any) => void;
}

export const PluginSettingItem = ({
  pluginkey,
  setting,
  onSettingChange,
}: PluginSettingItemProps) => {
  const input = () =>
    match(setting.type)
      .with('boolean', () => (
        <Checkbox
          onChange={() =>
            onSettingChange(pluginkey, setting.key, !setting.value)
          }
          checked={setting.value}
        />
      ))
      .with('string', () => (
        <TextInput
          value={setting.value}
          onChange={(event) =>
            onSettingChange(pluginkey, setting.key, event.currentTarget.value)
          }
          style={{ width: 120 }}
        />
      ))
      .with('number', () => (
        <NumberInput
          value={setting.value}
          onChange={(event) => onSettingChange(pluginkey, setting.key, event)}
          style={{ width: 120 }}
        />
      ))
      .with('select', () => (
        <Select
          data={setting.options ?? []}
          value={setting.value}
          onChange={(value) =>
            onSettingChange(pluginkey, setting.key, value ?? setting.default)
          }
          style={{ width: 160 }}
        />
      ))
      .exhaustive();

  return (
    <Group position="apart" spacing="lg" style={{ width: '100%' }}>
      <Text>{setting.name}</Text>
      {input()}
    </Group>
  );
};
